import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import RetinarLogo from '../../assets/images/lightblue_logo.png'
import Lock from '../../assets/icons/lock.svg'
import OpenEye from '../../assets/icons/open_eye.svg'
import CloseEye from '../../assets/icons/close_eye.svg'
import Footer from '../../components/Footer'
import ForgotPasswordModal from '../../components/Modal/CustomModals/ForgotPasswordModal'
import GenericModal from '../../components/Modal/GenericModal'
import {
  OutterContainer,
  InnerContainer,
  LogoWrapper,
  Logo,
  Title,
  FormWrapper,
  InputAndLabelWrapper,
  InputWrapper,
  Input,
  Label,
  LockIcon,
  EyeIconWrapper,
  EyeIcon,
  ForgotPassword,
  Button,
  ErrorMessage,
  SupportLink,
  PrincipalContainer
} from './styles'
import { useValidate } from '../../hooks/Login/useValidate'
import { LOGIN_RESULT } from '../../hooks/Login/Service/useLogin'
import { useModal } from '../../hooks/useModal'

const SUPPORT_EMAIL = 'soporte@retinar.com.ar'

const DEFAULT_DEACTIVATED_MESSAGE = `Tu cuenta ha sido desactivada. Por favor, contactá a un administrador del sistema o a ${SUPPORT_EMAIL}.`

const ERROR_CONTENT = {
  [LOGIN_RESULT.INVALID_CREDENTIALS]: () => 'Usuario o contraseña incorrectos',
  [LOGIN_RESULT.SERVICE_UNAVAILABLE]: () => (
    <>
      Ahora no pudimos validar tu ingreso. Reintentá en unos minutos.{' '}
      Si el problema persiste, escribí a{' '}
      <SupportLink href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</SupportLink>.
    </>
  )
}

export function Login () {
  const [showPassword, setShowPassword] = useState(false)
  const [data, setData] = useState({
    userName: '',
    password: ''
  })

  const [modalRef, openModal, closeModal] = useModal()

  const { validate } = useValidate()

  const [errorVariant, setErrorVariant] = useState(null)
  const [deactivatedModalOpen, setDeactivatedModalOpen] = useState(false)
  const [deactivatedMessage, setDeactivatedMessage] = useState(DEFAULT_DEACTIVATED_MESSAGE)

  useEffect(() => {
    const notice = sessionStorage.getItem('_retinar_session_notice')
    if (notice === 'deactivated') {
      setDeactivatedModalOpen(true)
      sessionStorage.removeItem('_retinar_session_notice')
    }
  }, [])

  const toggleShowPassword = () => {
    setShowPassword(prevState => !prevState)
  }

  const handleSubmit = async event => {
    event.preventDefault()
    setErrorVariant(null)

    let result
    try {
      result = await validate(data)
    } catch {
      setErrorVariant(LOGIN_RESULT.SERVICE_UNAVAILABLE)
      return
    }

    if (result.type === LOGIN_RESULT.ACCOUNT_DEACTIVATED) {
      if (result.mensaje) {
        const emailContact = result.soporteEmail || SUPPORT_EMAIL
        setDeactivatedMessage(`${result.mensaje} Contactá a ${emailContact}.`)
      }
      setDeactivatedModalOpen(true)
      return
    }

    if (result.type === LOGIN_RESULT.INVALID_CREDENTIALS || result.type === LOGIN_RESULT.SERVICE_UNAVAILABLE) {
      setErrorVariant(result.type)
    }
  }

  const changeHandler = event => {
    setData({ ...data, [event.target.name]: event.target.value })
    if (errorVariant) setErrorVariant(null)
  }

  const handleForgotPassword = () => {
    openModal()
  }

  const errorContent = errorVariant && ERROR_CONTENT[errorVariant] ? ERROR_CONTENT[errorVariant]() : null

  return (
    <PrincipalContainer>
      <OutterContainer>
        <LogoWrapper>
          <Link to='/'>
            <Logo src={RetinarLogo} alt='logo' />
          </Link>
        </LogoWrapper>
        <InnerContainer>
          <Title> Iniciar sesión </Title>
          <ErrorMessage aria-live='polite'>{errorContent}</ErrorMessage>
          <FormWrapper onSubmit={handleSubmit}>
            <InputAndLabelWrapper>
              <Label> Usuario </Label>
              <InputWrapper>
                <Input placeholder='Usuario' name='userName' onChange={changeHandler} />
              </InputWrapper>
            </InputAndLabelWrapper>

            <InputAndLabelWrapper>
              <Label> Contraseña </Label>
              <InputWrapper>
                <LockIcon src={Lock} alt='lock' />
                <Input type={showPassword ? 'text' : 'password'} placeholder='********' autoComplete='off' name='password' onChange={changeHandler} />
                <EyeIconWrapper onClick={toggleShowPassword}>
                  <EyeIcon src={showPassword ? OpenEye : CloseEye} alt='toggle-password' />
                </EyeIconWrapper>
              </InputWrapper>
            </InputAndLabelWrapper>

            <ForgotPassword type='button' onClick={handleForgotPassword}>
              Olvidé mi contraseña
            </ForgotPassword>

            <Button>
              Entrar
            </Button>
          </FormWrapper>
        </InnerContainer>
        <Footer />
      </OutterContainer>

      <ForgotPasswordModal ref={modalRef} close={closeModal} />

      <GenericModal
        isOpen={deactivatedModalOpen}
        onClose={() => setDeactivatedModalOpen(false)}
        title='Cuenta Desactivada'
        description={deactivatedMessage}
        withInput={false}
        saveButtonText='Entendido'
        showCancelButton={false}
        onSave={() => setDeactivatedModalOpen(false)}
      />
    </PrincipalContainer>
  )
}

export default Login
